<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
import { getPusherInstance } from '@/utils';

export default {
  name: 'FavSessionsDataProvider',
  created() {
    this.fetchItems();
    this.loadSortedBooksSesions();
    // Pull AI meetings + Open Sessions so the merged My Agenda getter has data
    // to combine with. Both stores have their own dedupe locks, so calling
    // these here is safe even when other providers already kicked them off.
    if (
      this.$store.hasModule
        ? this.$store.hasModule('MyMeetings')
        : !!this.$store.state.MyMeetings
    ) {
      this.$store.dispatch('MyMeetings/fetchTab', 'upcoming').catch(() => {});
    }
    if (
      this.$store.hasModule
        ? this.$store.hasModule('OpenSessions')
        : !!this.$store.state.OpenSessions
    ) {
      this.$store.dispatch('OpenSessions/fetchItems').catch(() => {});
    }
  },
  methods: {
    ...mapActions('BookSessions', [
      'fetchItems',
      'refresh',
      'loadSortedBooksSesions',
      'addOrDeleteBooksSesions'
    ])
  },
  computed: {
    ...mapGetters('BookSessions', [
      'getItems',
      'singleMyAgendaGroupedByDay',
      'mergedMyAgendaGroupedByDay',
      'getLoadingState'
    ])
  },
  render() {
    // TODO(23 jul. 2020) ~ Helge: We should not render until we have our data, make this a bit more clever and abstract it away
    if (this.isLoading) {
      return this.$scopedSlots.default({
        isLoading: this.isLoading
      });
    }
    return this.$scopedSlots.default({
      bookSessions: this.getItems,
      singleMyAgendaGroupedByDay: this.singleMyAgendaGroupedByDay,
      // New slot prop. Existing consumers reading singleMyAgendaGroupedByDay
      // are unaffected. My Agenda profile panel opts into mergedMyAgendaGroupedByDay.
      mergedMyAgendaGroupedByDay: this.mergedMyAgendaGroupedByDay,
      addOrDeleteBooksSesions: this.addOrDeleteBooksSesions,
      isBookSessionLoading: this.getLoadingState
    });
  }
};
</script>
